import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageKeys } from './shared/models/user';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const jwtToken = window.localStorage.getItem(LocalStorageKeys.Token);
    if (jwtToken) {
      const cloned = request.clone({
        headers: request.headers.set('Authorization', `Token ${jwtToken}`)
      });
      return next.handle(cloned);
    } else {
      return next.handle(request);
    }
  }
}
